"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugDeviceImpl = void 0;
const Logging_1 = require("../core/Logging");
const events_1 = require("events");
const ButtplugDeviceWriteOptions_1 = require("./ButtplugDeviceWriteOptions");
const ButtplugDeviceReadOptions_1 = require("./ButtplugDeviceReadOptions");
class ButtplugDeviceImpl extends events_1.EventEmitter {
    constructor(aName, aAddress) {
        super();
        this._logger = Logging_1.ButtplugLogger.Logger;
        this.WriteValue = (aValue, aOptions) => __awaiter(this, void 0, void 0, function* () {
            return yield this.WriteValueInternal(aValue, aOptions || new ButtplugDeviceWriteOptions_1.ButtplugDeviceWriteOptions());
        });
        this.ReadValue = (aOptions) => __awaiter(this, void 0, void 0, function* () {
            return yield this.ReadValueInternal(aOptions || new ButtplugDeviceReadOptions_1.ButtplugDeviceReadOptions());
        });
        this.WriteString = (aStr, aOptions) => __awaiter(this, void 0, void 0, function* () {
            return yield this.WriteValue(Buffer.from(aStr), aOptions);
        });
        this.ReadString = (aOptions) => __awaiter(this, void 0, void 0, function* () {
            const buf = yield this.ReadValue(aOptions);
            return buf.toString("utf-8");
        });
        this.SubscribeToUpdates = (aOptions) => __awaiter(this, void 0, void 0, function* () {
            return yield this.SubscribeToUpdatesInternal(aOptions || new ButtplugDeviceReadOptions_1.ButtplugDeviceReadOptions());
        });
        this._name = aName;
        this._address = aAddress;
    }
    get Name() {
        return this._name;
    }
    get Address() {
        return this._address;
    }
    UpdateReceived(aEndpoint, aData) {
        this.emit("updateReceived", [aEndpoint, aData]);
    }
}
exports.ButtplugDeviceImpl = ButtplugDeviceImpl;
//# sourceMappingURL=ButtplugDeviceImpl.js.map